module.exports = __webpack_public_path__ + "img/Wales.73eeacf7.svg";